var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"file-input",attrs:{"type":"file","accept":_vm.accept},on:{"change":function($event){$event.preventDefault();return _vm.handleInputFiles(_vm.$refs['file-input'].files)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }